import '@core/patches/date-fix';
import '@core/patches/global-helpers';

import Vue from 'vue';

import router from '@core/router';
import { Auth } from '@core/auth';
import ErrorService from '@core/services/ErrorService';
import '@core/services/CalculatorService';
import store from '@core/store';

import {
    attachInlineManualRouterSync,
    buildInlineManualPlayerOptions,
    initInlineManual
} from '@plugins/inlineManual';
import '@plugins/http';
import '@plugins/ideal-postcodes';
import '@/mixins';
import '@/directives';
import '@/global-components';
import '@plugins/lodash';
import i18n from '@plugins/i18n';
import vuetify from '@plugins/vuetify';

import App from '@/components/App.vue';
import '@/scss/app.scss';

Vue.config.productionTip = false;
if (import.meta.env.DEV) {
    // Vue 2: use the legacy browser extension (vite-plugin-vue-devtools is Vue 3 only).
    Vue.config.devtools = true;
}
Vue.config.errorHandler = (error, vm, info) => ErrorService.onError(error, { vm, info });

window.Vue = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#gi-app');

ErrorService.init();
const inlineManualPlayerOptions = () => buildInlineManualPlayerOptions({ language: i18n.locale });

initInlineManual({
    options: inlineManualPlayerOptions(),
    autoBoot: false
}).catch(error => {
    // Keep onboarding tooling failures non-fatal.
    console.warn('[InlineManual] Failed to initialise player script', error);
});

attachInlineManualRouterSync({
    router,
    getAuth: () => Auth(),
    getOptions: inlineManualPlayerOptions
});
